import { LastModifiedCell } from 'ui/indexPages/tables/cells/LastModifiedCell';
import { SnippetNameCell } from './SnippetNameCell';
import { SnippetContentCell } from './SnippetContentCell';
import { SnippetOverflowMenu } from './SnippetOverflowMenu';
import { TableGridRow } from './Styled';
import { GraphQLSnippet } from '../types';

type SnippetRowProps = {
  canManageSnippets: boolean;
  snippet: GraphQLSnippet;
  snippetRowGrid: string;
};

export const SnippetRow = ({ canManageSnippets, snippet, snippetRowGrid }: SnippetRowProps) => {
  const creator = snippet.creatorUser;
  const modifier = snippet.updatedByUser;
  const createdBy = { emailAddress: creator.id, ...creator };
  const modifiedBy = modifier ? { emailAddress: modifier.id, ...modifier } : null;

  return (
    <TableGridRow gridLayout={snippetRowGrid} key={snippet.id}>
      <SnippetNameCell snippet={snippet} canManageSnippets={canManageSnippets} />
      <SnippetContentCell snippet={snippet} />
      <LastModifiedCell
        data-test={'snippet-last-modified-cell'}
        createdAt={snippet.createdAt}
        createdBy={createdBy}
        modifiedBy={modifiedBy || undefined}
        modifiedAt={snippet.updatedAt}
        showAvatar={!!modifiedBy}
      />
      {canManageSnippets && (
        <SnippetOverflowMenu data-test={'snippet-overflow-menu'} snippet={snippet} smallButton />
      )}
    </TableGridRow>
  );
};
